<template>
  <v-alert
    v-model="authError.show"
    type="error"
    color="danger"
    border="left"
    dense
    outlined
    dismissible
  >
    <template v-slot:prepend>
      <v-icon color="danger" class="mr-3" v-text="mdiAccountAlert" />
    </template>
    <template v-slot:close>
      <v-icon
        class="ml-3"
        color="danger"
        v-text="mdiWindowClose"
        @click="closeNotice('authError')"
        title="Close" />
    </template>
    {{ authError.message }}
  </v-alert>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mdiAccountAlert, mdiWindowClose } from '@mdi/js';

export default {
  name: 'authErrorAlert',
  data() {
    return {
      mdiAccountAlert,
      mdiWindowClose
    }
  },
  computed: {
    ...mapGetters([
      'authError'
    ])
  },
  methods: {
    ...mapMutations([
      'closeNotice'
    ])
  }
};
</script>
